import googleAnalitycs from './google_analytics'

const Analytics = {
  install (Vue, options = {}) {
    Vue.prototype.$analytics = googleAnalitycs
  }
}

export default Analytics
